(function () {
  var TYPE_TO_PROP = {
    pointerdown: 'onPointerDown',
    pointerup: 'onPointerUp',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    click: 'onClick',
  };

  function findReactBtn() {
    return Array.from(document.querySelectorAll('.pai-btn')).find(function (btn) {
      var key = Object.keys(btn).find(function (k) {
        return k.startsWith('__reactProps');
      });
      return key && btn[key] && btn[key].onClick;
    });
  }

  function getReactProps(btn) {
    if (!btn) return null;
    var key = Object.keys(btn).find(function (k) {
      return k.startsWith('__reactProps');
    });
    return key ? btn[key] : null;
  }

  function syntheticEvent(reactBtn, type, original) {
    return {
      preventDefault: function () {},
      stopPropagation: function () {},
      isDefaultPrevented: function () { return false; },
      isPropagationStopped: function () { return false; },
      persist: function () {},
      nativeEvent: { stopImmediatePropagation: function () {}, preventDefault: function () {} },
      target: reactBtn,
      currentTarget: reactBtn,
      bubbles: true,
      type: type,
      pointerType: original && original.pointerType ? original.pointerType : 'mouse',
      pointerId: original && original.pointerId ? original.pointerId : 1,
      button: 0,
      clientX: original && original.clientX ? original.clientX : 0,
      clientY: original && original.clientY ? original.clientY : 0,
    };
  }

  function delegate(e) {
    var paiBtn = e.target && e.target.closest ? e.target.closest('.pai-btn') : null;
    if (!paiBtn) return;
    window._paiLastClickTarget = paiBtn;

    var reactBtn = findReactBtn();
    if (!reactBtn) return;
    if (paiBtn === reactBtn) return;

    var props = getReactProps(reactBtn);
    if (!props) return;
    var handler = props[TYPE_TO_PROP[e.type]];
    if (typeof handler !== 'function') return;

    e.stopPropagation();
    e.preventDefault();
    try {
      handler(syntheticEvent(reactBtn, e.type, e));
    } catch (err) {
      console.error('[pai-fix] handler error', err);
    }
  }

  function patchProductModal() {
    var ProductModal = customElements.get('product-modal');
    if (!ProductModal || ProductModal.prototype._paiPatched) return;
    var origShow = ProductModal.prototype.show;
    ProductModal.prototype.show = function (opener) {
      var lastTarget = window._paiLastClickTarget;
      if (lastTarget && lastTarget.closest && lastTarget.closest('.pai-btn')) {
        return;
      }
      origShow.call(this, opener);
    };
    ProductModal.prototype._paiPatched = true;
  }

  function start() {
    Object.keys(TYPE_TO_PROP).forEach(function (type) {
      document.addEventListener(type, delegate, true);
    });
    patchProductModal();
    var tries = 0;
    var i = setInterval(function () {
      patchProductModal();
      if (++tries > 20) clearInterval(i);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
